/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { transferBatchesControllerAddCustomersToBatch } from "./transferBatchesControllerAddCustomersToBatch";
import { transferBatchesControllerCreateBatch } from "./transferBatchesControllerCreateBatch";
import { transferBatchesControllerDeleteBatch } from "./transferBatchesControllerDeleteBatch";
import { transferBatchesControllerGetBatch } from "./transferBatchesControllerGetBatch";
import { transferBatchesControllerListBatches } from "./transferBatchesControllerListBatches";
import { transferBatchesControllerPatchBatch } from "./transferBatchesControllerPatchBatch";
import { transferBatchesControllerStartBatch } from "./transferBatchesControllerStartBatch";
import { transferBatchesControllerUpdateBatch } from "./transferBatchesControllerUpdateBatch";

export function transferBatchesService() {
  return { transferBatchesControllerCreateBatch, transferBatchesControllerListBatches, transferBatchesControllerGetBatch, transferBatchesControllerUpdateBatch, transferBatchesControllerPatchBatch, transferBatchesControllerDeleteBatch, transferBatchesControllerAddCustomersToBatch, transferBatchesControllerStartBatch }
}